import React from 'react';
import './App.css';
import { useParams } from "react-router-dom";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import BitcoinChart from './BitcoinChart';
import CustomDropdown from './CustomDropdown';

class YearList extends React.Component {
    render() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= 2012; year--) {
            years.push(<option key={year} value={year}>{year}</option>)
        }
        return (years);
    }    
}

class Mortgage extends React.Component {

    constructor(props) {
        super(props);
        let currentTime = new Date();

        let year = currentTime.getFullYear();
        if (props.params.year) {
           let paramYear = parseInt(props.params.year);
           if ((paramYear >= 2012) && (paramYear <= year)) {
                year = paramYear;
           }
        }

        let month = currentTime.getMonth() + 1;
        if (props.params.month) {
           let paramMonth = parseInt(props.params.month);
           if ((paramMonth >= 1) && (paramMonth <= 12)) {
                month = paramMonth;
           }
        }

        let downpayment = 0;
        if (props.params.downpayment) {
            let paramDownpayment = parseInt(props.params.downpayment);
            if ((paramDownpayment >= 0) && (paramDownpayment <= 50000000)) {
                downpayment = paramDownpayment;
            }
        }

        let monthly = 0;
        if (props.params.monthly) {
            let parammonthly = parseInt(props.params.monthly);
            if ((parammonthly >= 0) && (parammonthly <= 50000000)) {
                monthly = parammonthly;
            }
        }

        this.setDownpayment = this.setDownpayment.bind(this);
        this.setMonthlyPayment = this.setMonthlyPayment.bind(this);
        this.handleYear = this.handleYear.bind(this);
        this.handleMonth = this.handleMonth.bind(this);

        this.state = {
            downpayment: downpayment,
            monthlyPayment: monthly,
            totalPayment: 0,
            startYear: year,
            startMonth: month,
            initialBitcoin: 0,
            monthlyBitcoin: 0,
            bitcoinPrice: 0,
            shareText: "Share the Results!",
            prices: null
        };
    }

    recalculateBitcoinValues() {
        if (!this.state.prices) return;
        
        this.setState({
            initialBitcoin: this.getInitialBitcoin(
                this.state.downpayment,
                this.state.startYear,
                this.state.startMonth
            ),
            monthlyBitcoin: this.getMonthlyBitcoin(
                this.state.monthlyPayment,
                this.state.startYear,
                this.state.startMonth
            )
        });
    }

    componentDidMount() {
        // Use local file only when running on localhost
        const isLocalhost = window.location.hostname === 'localhost' || 
                          window.location.hostname === '127.0.0.1' ||
                          window.location.hostname.startsWith('192.168.');
        
        const pricesUrl = isLocalhost 
            ? "/prices.json"  // Local file for development
            : "https://prices.bitcoinmortgage.info/prices.json"; // Production API
            
        fetch(pricesUrl)
        .then(res => {
            if (!res.ok) throw new Error('Network response was not ok');
            return res.json();
        })
        .then(
            (result) => {
                // Commit prices first, then derive the BTC amounts in the callback —
                // the getters read this.state.prices, which isn't set until this
                // setState applies. (Computing them inline here reads the old null
                // prices and yields 0 on first load.)
                this.setState(
                    {
                        prices: result.prices,
                        bitcoinPrice: parseInt(result.current_price.usd),
                        totalPayment: this.getTotalPayment(
                            this.state.downpayment,
                            this.state.monthlyPayment,
                            this.state.startYear,
                            this.state.startMonth
                        )
                    },
                    () => this.recalculateBitcoinValues()
                );
            },
            (error) => {
                console.error("Failed to load price data:", error);
                this.setState({
                    error
                });
            })
    }
    

    getCurrentYearMonth() {
        let currentTime = new Date();
        let year = currentTime.getFullYear()
        let month = currentTime.getMonth() + 1;
        let yearMonth = year * 12 + month;
        return yearMonth;
    }

    getTotalPayment(downpayment, monthlyPayment, startYear, startMonth) {
        let yearMonth = this.getCurrentYearMonth();
        let startYearMonth = startYear * 12 + startMonth;
        let difference = yearMonth - startYearMonth;
        return difference * monthlyPayment + downpayment;
    }

    getInitialBitcoin(downpayment, startYear, startMonth) {
        if (typeof this.state.prices === 'undefined' || !this.state.prices) {
            return 0;
        }
        let yearMonth = startYear * 12 + startMonth;
        if (!this.state.prices[yearMonth] || this.state.prices[yearMonth].price === 0) {
            return 0;
        }
        let rate = this.state.prices[yearMonth].price;
        return downpayment/rate;
    }

    getMonthlyBitcoin(monthlyPayment, startYear, startMonth) {
        if (typeof this.state.prices === 'undefined' || !this.state.prices) {
            return 0;
        }
        let startYearMonth = startYear * 12 + (startMonth + 1);
        let yearMonth = this.getCurrentYearMonth();
        let monthPrice = 0;
        for (let ym = startYearMonth;ym <= yearMonth; ym++) {
            if (!this.state.prices[ym] || this.state.prices[ym].price === 0) {
                continue;
            }
            let rate = this.state.prices[ym].price;
            monthPrice += monthlyPayment/rate;
        }
        return monthPrice;
    }

    setDownpayment(event) {
        let downpayment = parseInt(event.target.value);
        if (isNaN(downpayment)) {
            downpayment = 0;
        }
        if (downpayment < 0) {
            downpayment = 0;
        }
        if (downpayment > 50000000) {
            downpayment = 50000000;
        }
        this.setState({
            downpayment: downpayment,
            totalPayment: this.getTotalPayment(
                downpayment,
                this.state.monthlyPayment,
                this.state.startYear,
                this.state.startMonth
            ),
            initialBitcoin: this.getInitialBitcoin(
                downpayment,
                this.state.startYear,
                this.state.startMonth
            )
        });
    }

    setMonthlyPayment(event) {
        let monthlyPayment = parseInt(event.target.value);
        if (isNaN(monthlyPayment)) {
            monthlyPayment = 0;
        }
        if (monthlyPayment < 0) {
            monthlyPayment = 0;
        }
        if (monthlyPayment > 5000000) {
            monthlyPayment = 5000000;
        }
        this.setState({
            monthlyPayment: monthlyPayment,
            totalPayment: this.getTotalPayment(
                this.state.downpayment,
                monthlyPayment,
                this.state.startYear,
                this.state.startMonth
            ),
            monthlyBitcoin: this.getMonthlyBitcoin(
                monthlyPayment,
                this.state.startYear,
                this.state.startMonth
            )
        });
    }

    handleYear(event) {
        let startYear = parseInt(event.target.value);
        this.setState({
            startYear: startYear,
            totalPayment: this.getTotalPayment(
                this.state.downpayment,
                this.state.monthlyPayment,
                startYear,
                this.state.startMonth
            ),
            initialBitcoin: this.getInitialBitcoin(
                this.state.downpayment,
                startYear,
                this.state.startMonth
            ),
            monthlyBitcoin: this.getMonthlyBitcoin(
                this.state.monthlyPayment,
                startYear,
                this.state.startMonth
            )
        });
    }

    handleMonth(event) {
        let startMonth = parseInt(event.target.value);
        this.setState({
            startMonth: startMonth,
            totalPayment: this.getTotalPayment(
                this.state.downpayment,
                this.state.monthlyPayment,
                this.state.startYear,
                startMonth
            ),
            initialBitcoin: this.getInitialBitcoin(
                this.state.downpayment,
                this.state.startYear,
                startMonth
            ),
            monthlyBitcoin: this.getMonthlyBitcoin(
                this.state.monthlyPayment,
                this.state.startYear,
                startMonth
            )
        });
    }

    getTotalBitcoin() {
        return this.state.initialBitcoin + this.state.monthlyBitcoin;
    }

    getTotalInvestmentValue() {
        let total = parseInt(this.state.bitcoinPrice * this.getTotalBitcoin());
        if (isNaN(total)) {
            total = 0;
        }
        return total;
    }

    formatDollar(num) {
        var p = num.toFixed(2).split(".");
        return p[0].split("").reverse().reduce(function(acc, num, i, orig) {
            return  num==="-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
        }, "");
    }

    getPermaUrl() {
        return "https://bitcoinmortgage.info/" +
            this.state.startYear + "/" +
            this.state.startMonth + "/" +
            this.state.downpayment + "/" +
            this.state.monthlyPayment;
    }

    getYearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= 2012; year--) {
            years.push({ value: year, label: year.toString() });
        }
        return years;
    }

    renderMortgage() {
        return (
            <div className="card mortgage-card">
                <div className="card-header">
                    <img className="card-icon" src="/icons/house-icon.png" alt="Mortgage"/>
                    <h2>Mortgage Details</h2>
                </div>
                <form className="card-form">
                    <div className="form-group">
                        <label>Start Date</label>
                        <div className="date-inputs">
                            <CustomDropdown
                                value={this.state.startYear}
                                onChange={this.handleYear}
                                options={this.getYearOptions()}
                                className="year-dropdown"
                            />
                            <CustomDropdown
                                value={this.state.startMonth}
                                onChange={this.handleMonth}
                                options={[
                                    { value: 1, label: 'January' },
                                    { value: 2, label: 'February' },
                                    { value: 3, label: 'March' },
                                    { value: 4, label: 'April' },
                                    { value: 5, label: 'May' },
                                    { value: 6, label: 'June' },
                                    { value: 7, label: 'July' },
                                    { value: 8, label: 'August' },
                                    { value: 9, label: 'September' },
                                    { value: 10, label: 'October' },
                                    { value: 11, label: 'November' },
                                    { value: 12, label: 'December' }
                                ]}
                                className="month-dropdown"
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Down Payment</label>
                        <div className="input-wrapper">
                            <span className="input-prefix">$</span>
                            <input type="text" onChange={this.setDownpayment} value={this.state.downpayment} placeholder="0" className="form-input"/>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Monthly Payment</label>
                        <div className="input-wrapper">
                            <span className="input-prefix">$</span>
                            <input type="text" onChange={this.setMonthlyPayment} value={this.state.monthlyPayment} placeholder="0" className="form-input"/>
                        </div>
                    </div>

                    <div className="form-group result-group">
                        <label>Total Spent</label>
                        <span className="result-value">${this.formatDollar(this.state.totalPayment)}</span>
                    </div>
                </form>
            </div>
        )
    }

    renderBitcoin() {
        return (
            <div className="card bitcoin-card">
                <div className="card-header">
                    <img className="card-icon" src="/icons/bitcoin-icon.png" alt="Bitcoin"/>
                    <h2>Bitcoin Investment</h2>
                </div>
                <form className="card-form">
                    <div className="form-group">
                        <label>Initial Investment</label>
                        <span className="btc-value">{parseFloat(this.state.initialBitcoin).toFixed(2)} BTC</span>
                    </div>

                    <div className="form-group">
                        <label>Total Monthly Investments</label>
                        <span className="btc-value">{parseFloat(this.state.monthlyBitcoin).toFixed(2)} BTC</span>
                    </div>

                    <div className="form-group">
                        <label>Total Bitcoin</label>
                        <span className="btc-value total">{parseFloat(this.getTotalBitcoin()).toFixed(2)} BTC</span>
                    </div>

                    <div className="form-group result-group">
                        <label>Current Value</label>
                        <span className="result-value">${this.formatDollar(this.getTotalInvestmentValue())}</span>
                    </div>
                </form>
            </div>
        )
    }

    render() {
        return (
          <div className="content-wrapper">
              <div className="cards-container">
                {this.renderMortgage()}
                {this.renderBitcoin()}
              </div>
              {this.state.prices && (
                <BitcoinChart
                  prices={this.state.prices}
                  startYear={this.state.startYear}
                  startMonth={this.state.startMonth}
                  downpayment={this.state.downpayment}
                  monthlyPayment={this.state.monthlyPayment}
                  currentPrice={this.state.bitcoinPrice}
                />
              )}
              <div className="share-section">
                  <CopyToClipboard
                    text={this.getPermaUrl()}
                    onCopy={() => this.setState({shareText: "Copied to Clipboard!"})}
                    >
                     <button className="share-button">{this.state.shareText}</button>
                  </CopyToClipboard>
              </div>
          </div>
        )
    }
}


function App() {
  let params = useParams();

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-container">
          <h1 className="nav-title">
            <span className="nav-bitcoin">Bitcoin</span>
            <span className="nav-mortgage">Mortgage</span>
          </h1>
          <p className="nav-subtitle">What if you bought Bitcoin instead of a house?</p>
        </div>
      </nav>
      <main className="main-content">
        <Mortgage params={params} />
      </main>

      <section className="seo-content" aria-label="About the Bitcoin vs. mortgage calculator">
        <div className="seo-inner">
          <article className="seo-article">
            <h2>What if you bought Bitcoin instead of a house?</h2>
            <p>
              <strong>Bitcoin Mortgage</strong> is a free calculator that compares the money you
              pour into a mortgage against what the same money would be worth had you invested it in
              Bitcoin instead. Enter your start date, down payment, and monthly payment, and the tool
              converts every dollar into the Bitcoin you could have bought at that month's price —
              using real historical BTC data going back to 2012 — then values your total holdings at
              today's price.
            </p>

            <h3>How the Bitcoin vs. mortgage comparison works</h3>
            <ol className="seo-steps">
              <li><strong>Pick your start date</strong> — any month from 2012 to today.</li>
              <li><strong>Enter your down payment</strong> — treated as a one-time lump-sum Bitcoin purchase at that month's price.</li>
              <li><strong>Enter your monthly payment</strong> — dollar-cost-averaged into Bitcoin every month since.</li>
              <li><strong>Compare</strong> — see your total spent, your accumulated BTC, and what it's worth today, charted against the money you put into a house and your estimated home equity.</li>
            </ol>

            <h3>Reading the chart</h3>
            <p>
              The chart overlays four lines: the historical <strong>Bitcoin price</strong>, the value of
              <strong> your wealth in BTC</strong>, the cumulative <strong>cash you put into the house</strong>,
              and your approximate <strong>home equity</strong>. Home equity is estimated from a standard
              30-year fixed amortization, so — like a real mortgage — it builds slowly at first (early
              payments are mostly interest) and accelerates over time.
            </p>

            <h2 className="seo-faq-title">Frequently asked questions</h2>
            <div className="seo-faq">
              <h3>What is the Bitcoin Mortgage calculator?</h3>
              <p>
                It's a free tool that shows what your house down payment and monthly mortgage payments
                would be worth today if you had invested that money in Bitcoin instead, using real
                historical Bitcoin prices back to 2012.
              </p>

              <h3>How does the Bitcoin vs. mortgage comparison work?</h3>
              <p>
                Enter your start date, down payment, and monthly payment. The calculator converts each
                payment into the Bitcoin you could have bought at that month's price, then values your
                total Bitcoin holdings at today's price so you can compare it against everything you spent.
              </p>

              <h3>Where does the Bitcoin price data come from?</h3>
              <p>
                Monthly historical Bitcoin prices from 2012 to today, plus the current price, are loaded
                from our public price feed and used to calculate dollar-cost-averaged returns.
              </p>

              <h3>Is the Bitcoin Mortgage calculator free?</h3>
              <p>
                Yes. It's completely free, requires no sign-up, and does not provide financial advice —
                it's for educational and comparison purposes only. Past performance does not guarantee
                future results, and Bitcoin is a highly volatile asset.
              </p>
            </div>
          </article>
        </div>
      </section>

      <footer className="site-footer">
        <p>
          Bitcoin Mortgage · A free Bitcoin vs. mortgage calculator. For educational purposes only —
          not financial advice.
        </p>
        <p className="footer-copyright">
          2026 © <a href="https://squidcode.com" target="_blank" rel="noopener noreferrer">Squidcode LLC</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
